<template>
  <div class="container-outline">
    <slot name="top-bar"></slot>

    <b-row>
      <b-col lg="1" class="d-block d-xl-none"> </b-col>
      <b-col
        xl="2"
        v-if="index == 0 && compare == 2"
        lg="1"
        cols="1"
        sm="1"
        md="1"
        class="d-none d-xl-block"
      >
        <slot name="side-bar-left"></slot>
      </b-col>
      <b-col
        xl="3"
        v-if="index == 0 && compare == 1"
        lg="1"
        cols="1"
        sm="1"
        class="d-none d-xl-block"
      >
        <slot name="full-bar-left"></slot>
      </b-col>
      <b-col
        :xl="compare == 2 ? 10 : 7"
        sm="12"
        :lg="compare == 2 ? 10 : 10"
        cols="12"
        md="12"
      >
        <b-container fluid>
          <slot name="main-content"></slot>
        </b-container>
      </b-col>
      <b-col
        v-if="index == 1"
        xl="2"
        lg="1"
        cols="1"
        sm="1"
        class="d-none d-md-inline-flex"
      >
        <slot name="right-side-bar"></slot>
      </b-col>
      <b-col
        v-if="index == 0 && compare == 1"
        xl="2"
        cols="1"
        sm="1"
        class="d-none d-md-inline-flex"
      >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ["compare", "index"],
};
</script>

<style>
</style>